export default {
    name: "AISHitsWrapper",

    data() {
        return {
            selectedMembers: [],
            showModal: false
        };
    },

    created() {},

    mounted() {
        console.info(`loading ${this.$options.name}`);
    }
};



// WEBPACK FOOTER //
// ./js/components/AisHitsWrapper.js